import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  requirePremium?: boolean;
  requireAdmin?: boolean;
}

export function ProtectedRoute({
  children,
  requirePremium = false,
  requireAdmin = false,
}: ProtectedRouteProps) {
  const { session, profile, loading, isPremium, isAdmin } = useAuth();
  const location = useLocation();

  if (loading && !session) {
    return <FullBleedSpinner />;
  }

  if (!session) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  if (loading && !profile) {
    return <FullBleedSpinner />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (requirePremium && !isPremium) {
    return <Navigate to="/membership" replace />;
  }

  return <>{children}</>;
}

function FullBleedSpinner() {
  return (
    <div className="flex h-full items-center justify-center bg-surface">
      <div className="size-10 animate-spin rounded-full border-2 border-primary/30 border-t-primary" />
    </div>
  );
}
